module.exports = __webpack_public_path__ + "img/payment_succeeded.c2b501aa.svg";